<template>
  <div class="page event-management">
    <management-nav
      @selectedTemplate="selectedTemplate"
      :preview="true"
      :event="event"
    ></management-nav>

    <div class="content" v-if="event">
      <div class="preview">
        <iframe
          :src="
            `https://journey-landing.firebaseapp.com/${event.template_id}/${event.slug}`
          "
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
  },
  data() {
    return {
      event: null,
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
    };
  },
  created() {},
  computed: {
    event_ref() {
      return db.collection("event").doc(this.$route.params.id);
    },
  },
  methods: {
    openNewTab() {
      window.open(
        `https://journey-landing.firebaseapp.com/${this.event.template_id}/${this.event.slug}`,
        "_blank"
      );
    },
    selectedTemplate(id) {
      this.event_ref.update({ template_id: id });
    },
  },
};
</script>

<style scoped lang="scss">
iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  padding-top: 150px;
  top: 0;
}

.preview {
  .btn {
    margin-bottom: 20px;
  }
}
</style>
